<div class="container table-page">
  @if (isLoading) {
  <aw-spinner [fullScreen]="true"></aw-spinner>
  }
  <aw-toast></aw-toast>
  <aw-divider
    [inset]="false"
    [middleInset]="false"
    [title]="'Customer Management'"
    [altColor]="false"
  >
  </aw-divider>

  <!-- Bar and table together, so the bar sits 8px above the table rather than a .container gap away. -->
  <div class="table-section">
    <app-table-action-bar>
      <aw-search
        class="table-action-bar__search"
        [(ngModel)]="searchInputValue"
        (ngModelChange)="onSearchInput(searchInputValue)"
        [placeholder]="'Search'"
        ariaLabel="Search Customers"
        [searchOptions]="selectionOptions"
      >
        <mat-icon [svgIcon]="'search'" position="prefix"></mat-icon>
      </aw-search>

      <aw-select-menu
        class="table-action-bar__filter"
        ariaLabel="Filter on Status"
        placeholder="Filter on Status"
        [formControl]="statusFilter"
        [multiSelectListItems]="statusFilterOptions"
      >
        <aw-form-field-label>Status</aw-form-field-label>
      </aw-select-menu>

      @if (userPermissions['canEdit']) {
      <button
        type="button"
        AwButton
        [buttonType]="'outlined'"
        [disable]="disableChangeStatus"
        (click)="openChangeStatusDialog = true"
      >
        Change Status
      </button>
      } @if (userPermissions['canCreate']) {
      <button
        type="button"
        class="table-action-bar__end"
        AwButton
        [buttonType]="'primary'"
        (click)="openAddCustomer()"
      >
        Add Customer
      </button>
      }
    </app-table-action-bar>

    <!-- Re-created across the phone breakpoint: aw-table reads its scroll mode once, on init. -->
    @for (mode of [isPhone() ? 'phone' : 'desktop']; track mode) {
      <aw-table
        [columnsDefinition]="columnsDefinition"
        [tableData]="tableData()"
        [tableHeight]="isPhone() ? '' : '100%'"
        [enableInfiniteScroll]="!isPhone()"
        [displayableRowsCount]="50"
        [enableStickyOptions]="enableStickyOptions()"
        [sortDisabled]="sortDisabled()"
        (checkboxList)="checkBoxActionHandler($event)"
      >
      </aw-table>
    }
    <aw-footer [resultsCount]="tableData().length"></aw-footer>
    <app-results-status [count]="tableData().length"></app-results-status>
  </div>

  <aw-dialog
    [visible]="openChangeStatusDialog"
    [formFieldsData]="formFieldsData()"
    [dialogOptions]="dialogOptionsStatus()"
    (primaryAction)="dialogFormValuesHandler($event, 'status')"
    (secondaryAction)="dialogCloseHandler('status')"
    ariaLabel="Change customer status"
  >
  </aw-dialog>

  <aw-dialog
    [visible]="openDeleteCustomerDialog"
    [dialogOptions]="dialogOptionsDelete"
    (primaryAction)="dialogFormValuesHandler($event, 'delete')"
    (secondaryAction)="dialogCloseHandler('delete')"
    ariaLabel="Delete customer"
  >
  </aw-dialog>
</div>
